const IconSettings = function () {
	return (
		<svg className="icon icon-settings" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path strokeLinecap="round" d="M17.5 13v7M6.5 4.5V7M12 4.5V13M17.5 4.5V8M6.5 12v8M12 18v2"/><rect width="3" height="5" x="5" y="7" rx="1.5"/><rect width="3" height="5" x="10.5" y="13" rx="1.5"/><rect width="3" height="5" x="16" y="8" rx="1.5"/></svg>
	)
}

export default IconSettings;